module.exports = __webpack_public_path__ + "img/navbar-item-active.13d3b1d.webp";